import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Users, FileSpreadsheet, GraduationCap, Settings as SettingsIcon,
  Calendar, Link as LinkIcon, UserCheck, BookOpen, LayoutDashboard,
  Flag, History, Activity, CreditCard, MessageSquareText, ListChecks, KeyRound,
} from "lucide-react";
import EnquiriesTab from "@/pages/admin/EnquiriesTab";
import EnquiryFormTab from "@/pages/admin/EnquiryFormTab";
import AdminConfigTab from "@/pages/admin/AdminConfigTab";
import PaymentsTab from "@/pages/admin/PaymentsTab";
import StudentActivityTab from "@/pages/admin/StudentActivityTab";
import QuestionsPanel from "@/pages/admin/_QuestionsPanel";
import SubjectsPanel from "@/pages/admin/_SubjectsPanel";
import UsersPanel from "@/pages/admin/_UsersPanel";
import SettingsTab from "@/pages/admin/SettingsTab";
import CoursesTab from "@/pages/admin/CoursesTab";
import EnrollmentsTab from "@/pages/admin/EnrollmentsTab";
import SchedulesTab from "@/pages/admin/SchedulesTab";
import ResourcesTab from "@/pages/admin/ResourcesTab";
import OverviewTab from "@/pages/admin/OverviewTab";
import ReportsTab from "@/pages/admin/ReportsTab";
import AuditLogTab from "@/pages/admin/AuditLogTab";

export default function Admin() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
      <div className="mb-6">
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[hsl(var(--brand-orange))]">Admin</div>
        <h1 className="mt-1 font-display text-3xl font-bold">PilotYatra control tower</h1>
        <p className="mt-1 text-sm text-muted-foreground">Manage every corner of the platform — content, courses, students, schedules, resources, branding.</p>
      </div>
      <Tabs defaultValue="overview" className="mt-6">
        <TabsList className="h-auto flex-wrap gap-1">
          <TabsTrigger value="overview" data-testid="tab-overview"><LayoutDashboard className="mr-1.5 h-4 w-4" />Overview</TabsTrigger>
          <TabsTrigger value="activity" data-testid="tab-activity"><Activity className="mr-1.5 h-4 w-4" />Student Activity</TabsTrigger>
          <TabsTrigger value="questions" data-testid="tab-questions"><FileSpreadsheet className="mr-1.5 h-4 w-4" />Questions</TabsTrigger>
          <TabsTrigger value="subjects" data-testid="tab-subjects"><BookOpen className="mr-1.5 h-4 w-4" />Subjects</TabsTrigger>
          <TabsTrigger value="courses" data-testid="tab-courses"><GraduationCap className="mr-1.5 h-4 w-4" />Courses</TabsTrigger>
          <TabsTrigger value="enrollments" data-testid="tab-enrollments"><UserCheck className="mr-1.5 h-4 w-4" />Enrollments</TabsTrigger>
          <TabsTrigger value="payments" data-testid="tab-payments"><CreditCard className="mr-1.5 h-4 w-4" />Payments</TabsTrigger>
          <TabsTrigger value="enquiries" data-testid="tab-enquiries"><MessageSquareText className="mr-1.5 h-4 w-4" />Enquiries</TabsTrigger>
          <TabsTrigger value="enquiry-form" data-testid="tab-enquiry-form"><ListChecks className="mr-1.5 h-4 w-4" />Enquiry Form</TabsTrigger>
          <TabsTrigger value="config" data-testid="tab-config"><KeyRound className="mr-1.5 h-4 w-4" />Payment & Email</TabsTrigger>
          <TabsTrigger value="schedules" data-testid="tab-schedules"><Calendar className="mr-1.5 h-4 w-4" />Schedules</TabsTrigger>
          <TabsTrigger value="resources" data-testid="tab-resources"><LinkIcon className="mr-1.5 h-4 w-4" />Links & Resources</TabsTrigger>
          <TabsTrigger value="users" data-testid="tab-users"><Users className="mr-1.5 h-4 w-4" />Users</TabsTrigger>
          <TabsTrigger value="reports" data-testid="tab-reports"><Flag className="mr-1.5 h-4 w-4" />Reports</TabsTrigger>
          <TabsTrigger value="audit" data-testid="tab-audit"><History className="mr-1.5 h-4 w-4" />Audit Log</TabsTrigger>
          <TabsTrigger value="settings" data-testid="tab-settings"><SettingsIcon className="mr-1.5 h-4 w-4" />Site Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="overview" className="mt-4"><OverviewTab /></TabsContent>
        <TabsContent value="activity" className="mt-4"><StudentActivityTab /></TabsContent>
        <TabsContent value="questions" className="mt-4"><QuestionsPanel /></TabsContent>
        <TabsContent value="subjects" className="mt-4"><SubjectsPanel /></TabsContent>
        <TabsContent value="courses" className="mt-4"><CoursesTab /></TabsContent>
        <TabsContent value="enrollments" className="mt-4"><EnrollmentsTab /></TabsContent>
        <TabsContent value="payments" className="mt-4"><PaymentsTab /></TabsContent>
        <TabsContent value="enquiries" className="mt-4"><EnquiriesTab /></TabsContent>
        <TabsContent value="enquiry-form" className="mt-4"><EnquiryFormTab /></TabsContent>
        <TabsContent value="config" className="mt-4"><AdminConfigTab /></TabsContent>
        <TabsContent value="schedules" className="mt-4"><SchedulesTab /></TabsContent>
        <TabsContent value="resources" className="mt-4"><ResourcesTab /></TabsContent>
        <TabsContent value="users" className="mt-4"><UsersPanel /></TabsContent>
        <TabsContent value="reports" className="mt-4"><ReportsTab /></TabsContent>
        <TabsContent value="audit" className="mt-4"><AuditLogTab /></TabsContent>
        <TabsContent value="settings" className="mt-4"><SettingsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
